import { FeatureFlag, useFeatureFlagsStore } from 'stores/featureFlagsStore';

export function useMeetingNotesAccess(): boolean {
  return useFeatureFlagsStore((state) =>
    state.isFeatureEnabled(FeatureFlag.meeting_notes_access)
  );
}
